import { Fragment, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useModalState } from 'hooks'
import { useGetFollowersQuery } from 'store/api/yay/user'

import AvatarHorizontalList from 'components/Avatar/AvatarHorizontalList'
import MutualFollowingModal from './components/MutualFollowingModal'

import './style.scss'

type MutualFollowingProps = {
  userId: number
}

const MutualFollowing = ({ userId }: MutualFollowingProps) => {
  const { t } = useTranslation()

  const mutualFollowingModal = useModalState()

  const followersRes = useGetFollowersQuery({ userId, followedByMe: true })

  useEffect(() => {
    mutualFollowingModal.close()
  }, [userId])

  const users = (followersRes?.data?.users ?? [])?.slice?.(0, 3)

  return (
    <Fragment>
      <div
        className="MutualFollowing"
        role="button"
        onClick={() => mutualFollowingModal.open()}
      >
        <AvatarHorizontalList users={users} />

        <div className="MutualFollowing__name_list">
          {users.reduce((acc: any, user: any, i: number) => {
            return `${acc}${t('mutual_following.name_list.name', {
              nickname: user.nickname,
            })}${
              i !== users.length - 1
                ? ', '
                : followersRes?.data?.users?.length > 3
                ? t('mutual_following.name_list.last_over_3_members')
                : t('mutual_following.name_list.last_less_3_members')
            }`
          }, '')}
        </div>
      </div>

      <MutualFollowingModal
        isActive={mutualFollowingModal.isActive}
        onClose={mutualFollowingModal.close}
        userId={userId}
      />
    </Fragment>
  )
}

export default MutualFollowing
